import React from 'react';
import { Route, Switch } from 'react-router';

import Home from './../pages/Admin/Home/Home';
import Playground from './../components/Playground';
import TestRefDashboard from '../pages/Admin/TestRefDashboard';
import TestStartScreen from '../pages/Tests/TestStartScreen';
import Test from '../pages/Tests/Test';
import ResultScreen from '../pages/Tests/ResultScreen';
import ProfileDashboard from '../pages/Admin/ProfileDashboard';
import Dictionary from '../pages/Documents/Dictionary';
import GlobalInfo from '../pages/Documents/GlobalInfo';
import Leaderboard from '../pages/Documents/Leaderboard';
import Report from '../pages/Documents/Report';
import Resources from '../pages/Documents/Resources';
import TestHistory from '../pages/Documents/TestHistory';
import Login from './../pages/Admin/Login';
import RegisterPage1 from './../pages/Admin/RegisterPage1';
import RegisterPage2 from './../pages/Admin/RegisterPage2';
import ForgotPassword from './../pages/Admin/ForgotPassword';
import EditAccount from './../pages/Admin/EditAccount';
import Review from "../pages/Reviews/Review";
import Results from "../pages/Results/Results";
import Memo from "../pages/Memo/Memo"
import Solution from "../pages/Partials/Solution";
import EditReviewQuestion from "../pages/Tests/EditReviewQuestion"
import ReferenceList from "../pages/Tests/ReferenceList";
import ResourcesDashboard from "../pages/Admin/Home/ResourcesDashboard";
import ReportDashboard from "../pages/Admin/ReportDashboard";
import HistoryDashboard from "../pages/Admin/HistoryDashboard";
import AccountDashboard from "../pages/Admin/AccountDashboard";
import LeaderboardDashboard from "../pages/Admin/LeaderboardDashboard";
import TestDashboard from "../pages/Admin/Home/TestDashboard";
import EditPassword from "../pages/Admin/EditPassword";
import ChangePassword from "../pages/Admin/ChangePassword";
import ContactUs from "../pages/Admin/ContactUsPage";


const Routes = [
  {
    path: '/',
    key: 'ROOT',
    exact: true,
    component: () => <Home></Home>,
  },
  //GR1 -- Do not remove comment
  {
    path: '/users',
    key: 'USERS',
    exact: true,
    component: RenderRoutes,
    routes: [],
  },
  {
    path: '/home',
    key: 'HOME',
    exact: true,
    component: Home,
  },
  {
    path: '/playground',
    key: 'PLAYGROUND',
    exact: true,
    component: Playground,
  },
  {
    path: '/login',
    key: 'LOGIN',
    exact: true,
    component: Login,
  },
  {
    path: '/registerpage1',
    key: 'REGISTERPAGE1',
    exact: true,
    component: RegisterPage1,
  },
  {
    path: '/solution',
    key: 'SOLUTION',
    exact: true,
    component: Solution,
  },
  {
    path: '/registerpage2/:id/:token',
    key: 'REGISTERPAGE2',
    exact: true,
    component: RegisterPage2,
  },
  {
    path: '/forgotpassword',
    key: 'FORGOTPASSWORD',
    exact: true,
    component: ForgotPassword,
  },
  {
    path: '/testrefdashboard',
    key: 'TESTREFDASHBOARD',
    exact: true,
    component: TestRefDashboard,
  },
  {
    path: '/profile',
    key: 'PROFILE',
    exact: true,
    component: AccountDashboard,
  },
  {
    path: '/editaccount',
    key: 'EDITACCOUNT',
    exact: true,
    component: EditAccount,
  },
  {
    path: '/teststart',
    key: 'TESTSTART',
    exact: true,
    component: TestStartScreen,
  },
  {
    path: '/test',
    key: 'TEST',
    exact: true,
    component: Test,
  },
  {
    path: '/results',
    key: 'RESULTS',
    exact: true,
    component: ResultScreen,
  },
  {
    path: '/memo',
    key: 'MEMO',
    exact: true,
    component: Memo
  },
  {
    path: '/dictionary',
    key: 'DICTIONARY',
    exact: true,
    component: Dictionary,
  },
  {
    path: '/globalinfo',
    key: 'GLOBALINFO',
    exact: true,
    component: GlobalInfo,
  },
  {
    path: '/history',
    key: 'HISTORY',
    exact: true,
    component: HistoryDashboard,
  },
  {
    path: '/leaderboard',
    key: 'LEADERBOARD',
    exact: true,
    component: LeaderboardDashboard,
  },
  {
    path: '/resources',
    key: 'RESOURCES',
    exact: true,
    component: Resources,
  },
  {
    path: '/review',
    key: 'REVIEW',
    exact: true,
    component: Review,
  },
  {
    path: '/testresults',
    key: 'TESTRESULTS',
    exact: true,
    component: Results,
  },
  {
    path: '/editquestion',
    key: 'EDITQUESTION',
    exact: true,
    component: EditReviewQuestion
  },
  {
    path: '/testdashboard',
    key: 'TESTDASHBOARD',
    exact: true,
    component: TestDashboard
  },
  {
    path: '/resourcedashboard',
    key: 'RESOURCEDASHBOARD',
    exact: true,
    component: ResourcesDashboard
  },
  {
    path: '/report',
    key: 'REPORT',
    exact: true,
    component: ReportDashboard
  },
  {
    path: '/changepassword/:id/:token',
    key: 'CHANGEPASSWORD',
    exact: true,
    component: ChangePassword
  },
  {
    path: 'contactus',
    key: 'CONTACTUS',
    exact: true,
    component: ContactUs
  }
];

export default Routes;

function RouteWithSubRoutes(route) {
  return (
    <Route
      path={route.path}
      exact={route.exact}
      render={(props) => <route.component {...props} routes={route.routes} />}
    />
  );
}

export function RenderRoutes({ routes }) {
  return (
    <Switch>
      {routes.map((route, i) => {
        return <RouteWithSubRoutes key={route.key} {...route} />;
      })}
      <Route exact path="/login">
        <Login />
      </Route>
      <Route exact path="/registerpage1">
        <RegisterPage1 />
      </Route>
      <Route exact path="/registerpage2/:id/:token">
        <RegisterPage2 />
      </Route>
      <Route exact path="/forgotpassword">
        <ForgotPassword />
      </Route>
      <Route exact path="/testrefdashboard">
        <TestRefDashboard />
      </Route>
      <Route exact path="/profile">
        <AccountDashboard />
      </Route>
      <Route exact path="/editaccount">
        <EditAccount />
      </Route>
      <Route exact path="/teststart">
        <TestStartScreen />
      </Route>
      <Route exact path="/test">
        <Test />
      </Route>
      <Route exact path="/results">
        <ResultScreen />
      </Route>
      <Route exact path="/dictionary">
        <Dictionary />
      </Route>
      <Route exact path="/globalinfo">
        <GlobalInfo />
      </Route>
      <Route exact path="/leaderboard">
        <LeaderboardDashboard />
      </Route>
      <Route exact path="/report">
        <ReportDashboard />
      </Route>
      <Route exact path="/resources">
        <Resources />
      </Route>
      <Route exact path="/history">
        <HistoryDashboard />
      </Route>
      <Route exact path="/review">
        <Review />
      </Route>
      <Route exact path="/testresults">
        <Results />
      </Route>
      <Route exact path = "/editquestion">
        <EditReviewQuestion />
      </Route>
      <Route exact path="/testdashboard">
        <TestDashboard />
      </Route>
      <Route exact path="/resourcedashboard">
        <ResourcesDashboard />
      </Route>
      <Route exact path="/changepassword/:id/:token">
        <ChangePassword />
      </Route>
      <Route exact path="/contactus">
        <ContactUs />
      </Route>
      <Route component={() => <h1 style={{color: 'white'}}>Not Found!</h1>} />
    </Switch>
  );
}
